import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-ehms.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-ehms.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ViewApplicationService } from "../../../view-application.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationDetailsEhmsConstants } from "./view-application-details-ehms.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { EhApplicationTypeEnum } from "../../../../../shared/models/application/eh/eh-application-type-enum.model";
import { SelectedApplicationService } from "../../../../../shared/services/selected-application/selected-application.service";
import { DatePipe } from "@angular/common";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { LookupConstants } from "../../../../../shared/constants/lookup.constants";
let ViewApplicationDetailsEhmsComponent = class ViewApplicationDetailsEhmsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    viewApplicationService;
    appController;
    route;
    datePipe;
    selectedApplicationService;
    requestStatusService;
    changeDetectorRefs;
    routerParamsService;
    detailsForm;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    validationMessages = ViewApplicationDetailsEhmsConstants.VALIDATION_MESSAGES;
    referenceNumberFormControlName = ViewApplicationDetailsEhmsConstants.REFERENCE_NUMBER_FORM_CONTROL_NAME;
    descriptionFormControlName = ViewApplicationDetailsEhmsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    startDateFormControlName = ViewApplicationDetailsEhmsConstants.START_DATE_FORM_CONTROL_NAME;
    communicationMethodFormControlName = ViewApplicationDetailsEhmsConstants.COMMUNICATION_METHOD_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsEhmsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    applicationTypeLabel = ViewApplicationDetailsEhmsConstants.APPLICATION_TYPE_LABEL;
    referenceNumberLabel = ViewApplicationDetailsEhmsConstants.REFERENCE_NUMBER_LABEL;
    descriptionLabel = ViewApplicationDetailsEhmsConstants.DESCRIPTION_LABEL;
    startDateLabel = ViewApplicationDetailsEhmsConstants.START_DATE_LABEL;
    communicationMethodLabel = ViewApplicationDetailsEhmsConstants.COMMUNICATION_METHOD_LABEL;
    lookupType = ViewApplicationDetailsEhmsConstants.COMMUNICATION_METHOD_LOOKUP_TYPE;
    applicationTypes = [];
    communicationTypes = [];
    referenceNumber = "";
    subscription;
    application;
    getApplicationObservableSubscription;
    getApplicationSaveObservableSubscription;
    constructor(aflaModuleStrategyService, viewApplicationService, appController, route, datePipe, selectedApplicationService, requestStatusService, changeDetectorRefs, routerParamsService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.appController = appController;
        this.route = route;
        this.datePipe = datePipe;
        this.selectedApplicationService = selectedApplicationService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
    }
    handleRouteChange() {
        this.applicationTypes = [];
        // tslint:disable-next-line:forin
        for (const type in EhApplicationTypeEnum) {
            if (isNaN(Number(type)))
                this.applicationTypes.push({ value: type, name: EhApplicationTypeEnum[type] });
            this.applicationTypes.sort((a, b) => (a.name?.localeCompare(b?.name)));
        }
        if (this.aflaModuleStrategyService.lookups.has(this.lookupType)) {
            this.communicationTypes = LookupConstants.COMMUNICATION_MECHANISM;
            this.communicationTypes.sort((a, b) => (a?.localeCompare(b)));
            this.getCurrentApplication();
        }
        else {
            this.onGetLookups();
        }
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    ngOnDestroy() {
    }
    onGetLookups() {
        this.communicationTypes = LookupConstants.COMMUNICATION_MECHANISM;
        this.communicationTypes.sort((a, b) => (a?.localeCompare(b)));
        this.aflaModuleStrategyService.lookups.set(this.lookupType, this.communicationTypes);
        this.changeDetectorRefs.markForCheck();
        this.getCurrentApplication();
    }
    getCurrentApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID}`,
        };
        this.getApplicationObservableSubscription = this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params).subscribe({
            next: response => {
                if (response && response.value.length > 0) {
                    this.populateForm(response.value[0]);
                }
            },
            error: error => {
                this.requestStatusService.removeBusySpinner("LoadingApplications");
                this.appController.handleServerErrorMessage(ViewApplicationDetailsEhmsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    populateForm(ehApp) {
        if (ehApp) {
            this.detailsForm.reset();
            const application = ehApp;
            this.application = application;
            this.referenceNumber = application.referenceNumber;
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
            const date = new Date(application.applicationStartDate);
            const dateString = this.datePipe.transform(date, "yyyy-MM-dd");
            this.detailsForm.get(this.startDateFormControlName).setValue(dateString);
            this.detailsForm.get(this.communicationMethodFormControlName).setValue(application.communicationMethod);
            this.detailsForm.get(this.applicationTypeFormControlName).setValue(application.applicationType);
        }
        this.changeDetectorRefs.detectChanges();
        this.changeDetectorRefs.markForCheck();
    }
    // TODO: @Lawrence - Done - EHApplication.ReferenceNumber (readonly) textbox required on edit application details
    onButtonSaveClicked() {
        if (this.detailsForm.valid) {
            const app = {
                description: this.detailsForm.get(this.descriptionFormControlName).value,
                applicationStartDate: this.detailsForm.get(this.startDateFormControlName).value,
                communicationMethod: this.detailsForm.get(this.communicationMethodFormControlName).value,
                applicationType: this.detailsForm.get(this.applicationTypeFormControlName).value
            };
            this.getApplicationSaveObservableSubscription = this.viewApplicationService.getApplicationSaveObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.application.id, app)
                .subscribe({
                next: () => {
                    this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                    this.getCurrentApplication();
                }, error: (error) => {
                    this.appController.handleServerErrorMessage(ViewApplicationDetailsEhmsConstants.STEP_TITLE, error, CRUDOperation.Get);
                }
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: AppControllerService },
        { type: ActivatedRoute },
        { type: DatePipe },
        { type: SelectedApplicationService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsEhmsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-details-ehms",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsEhmsComponent);
export { ViewApplicationDetailsEhmsComponent };
